import { IApplication } from 'src/app/models/interfaces/application.interface';
import { FormMode } from '../../controls/common/form-mode';

export class ApplicationFormContext {
    /**
     * Instance de l'application affiché dans le formulaire.
     */
    public item: IApplication;

    /**
     * Indique si le formulaire est visible (true) ou pas (false).
     */
    public formVisible = false;

    public mode: FormMode = FormMode.Reading;
}
